<template src="../templates/welcome.html"></template>
<script>
    import ContactModel from "../models/contactModel";
    import FileModel from "../models/fileModel";
    import OutstandingInvoicesCollection from "@/collections/outstandingInvoicesCollection";
    import WelcomePageCollections from "@/collections/welcomePageCollections";
    import InterpreterPromoteCarousel from "@/components/InterpreterPromoteCarousel"
    import {authorizationService} from '../authorization/authorizationService';
    import {commonFunctions} from "@/common/commonFunctions";
    import ClientDashboardCollection from "@/collections/clientDashboardCollection";
    import ReportsAndStatistics from "@/components/dashboard/ReportsAndStatistics";
    import StaticWelcomeEdu from "@/components/StaticWelcomeEdu";
    import StaticWelcomeKind from "@/components/StaticWelcomeKind";

    export default {
        name: 'Welcome',
        components: {
            InterpreterPromoteCarousel, ReportsAndStatistics, StaticWelcomeEdu, StaticWelcomeKind
        },
        data() {
            return {
              contactModel: {},
              fileModel: new FileModel(),
              userManualLink: "",
              outstandingInvoicesCollection: new OutstandingInvoicesCollection,
              welcomePageCollections: new WelcomePageCollections,
              countOutstandingInvoice: true,
              totalOutstandingInvoices: 0,
              outstandingInvoicesVisible: false,
              styleObject: {
                "overflow-y": "auto",
                height: this.getCarouselHeight()
              },
              pages: [],
              clientDashboardCollection: new ClientDashboardCollection,
              isStaticWelcomePage: false,
            }
        },
        methods: {
          buildBadge(tag) {
        console.log('yes');
            let num = this.$data[tag.badge_num.toString()];
        return tag.content + "<span class='badge badge-warning'><h6 class='m-0'>" + num + "</h6></span>";
          },
          loadDetails: function () {
              this.contactModel = new ContactModel();

              let url = this.$localApiURL + this.contactModel.getRoute("fetch") + "?token=" + localStorage.getItem('jwt');
              this.$http.get(url).then((res) => {

                  this.contactModel = res.data;
                this.loadUserGuideId();
              }).catch((error) => {
                  console.error(error);
              });

              authorizationService.authorize("/OutstandingInvoices").then((res) => {

                  this.outstandingInvoicesVisible = res.data.result === 1;
              }).catch((error) => {
                  console.error(error);
              });

              // Pull the dynamic content of the welcome page from the database
              let welcomeContentUrl = this.$localApiURL + this.welcomePageCollections.getRoute("fetch") + "?token=" + localStorage.getItem('jwt');
              this.$http.get(welcomeContentUrl).then((res) => {

                if(res.data.static_welcome === 'EDU' || res.data.static_welcome === 'KIND') {
                  this.isStaticWelcomePage = res.data.static_welcome;
                }

                this.welcomePageCollections.models = res.data;

                console.log("welcome page dynamic")
                console.log(this.welcomePageCollections.models)

              }).catch((error) => {
                console.error(error);
              });
          },
          buildHTML(htmlTag) {
            let thisComp = this;
            let html = '';
            let htmlTagProperties;
            let childTagProperties;
            let htmlTagContent;
            let childTagContent;

            console.log('htmlTag');
            console.log(htmlTag);

            if (htmlTag.isGraph === true) {

              let boards = htmlTag.content;

              // If it has a content
              if (boards.length > 0) {
                let thisComp = this;
                let tagProperties = '';
                let tagContent = '';
                let childTagContent = '';
                let childTagProperties = '';
                boards.forEach((board) => {

                  console.log('board')
                  console.log(board)

                  tagProperties = commonFunctions.buildProperty(thisComp.$data, board.properties);
                  tagContent = commonFunctions.buildContent(board.content);

                  // Opening parent html tag including its properties and innerHTML.
                  html += '<' + board.tag + ' ' + tagProperties + '>' + tagContent;


                  if (board.childTags.length > 0) {
                    // Child tag iteration.
                    board.childTags.forEach((childTag) => {
                      childTagProperties = commonFunctions.buildProperty(thisComp.$data, childTag.properties);
                      childTagContent = commonFunctions.buildContent(childTag.content);

                      // Opening child html tag including its properties, innerHTML and closing tag.
                      html += '<' + childTag.tag + ' ' + childTagProperties + '>'
                        + childTagContent + '<\/' + childTag.tag + '>';
                    });
                  }

                  // Closing tag of parent.
                  html += '<\/' + board.tag + '>';
                });

              }

              // Return the above built html.
              return html;
            }
            else {
                  // Initiate the html variable.
                  htmlTagProperties = this.getPropertyValue(htmlTag);
                  htmlTagContent = this.checkIfBadge(htmlTag);

                  if ( this.hideRow != true ) {
                    // If it has a child tag, iterate the child tag wrapped by parent tag as below.
                    if (htmlTag.childTags.length > 0) {
                      // Opening parent html tag including its properties and innerHTML.
                      html += '<' + htmlTag.tag + ' ' + htmlTagProperties + '>'
                        // innerHTML content.
                        + htmlTagContent;

                      // Child tag iteration.
                      htmlTag.childTags.forEach((childTag) => {
                        childTagProperties = thisComp.getPropertyValue(childTag);
                        childTagContent = thisComp.checkIfBadge(childTag);

                        // Opening child html tag including its properties, innerHTML and closing tag.
                        html += '<' + childTag.tag + ' ' + childTagProperties + '>'
                          + childTagContent + '<\/' + childTag.tag + '>';
                      });

                      // Closing tag of parent.
                      html += '<\/' + htmlTag.tag + '>';
                    }
                    // Else, it has no child tag.
                    else {
                      // Opening html tag including its properties, innerHTML content and closing tag in one line.
                      html += '<' + htmlTag.tag + ' ' + htmlTagProperties + '>' + htmlTagContent + '<\/' + htmlTag.tag + '>'
                    }
                  }
                  else this.hideRow = false;


                  // Return the above built html.
                  return html;
            }
          },
          checkIfBadge(tag) {
                let tagContent = '';
            if ( tag.badge_num != null ) {
              tagContent = this.buildBadge(tag);
            }
            else tagContent = (tag.content != null ? tag.content : '' );

            return tagContent;
          },
          buildGraphHTML(board) {
            let thisComp = this;
            let tagProperties = '';
            let tagContent = '';
            let childTagContent = '';
            let childTagProperties = '';
            let html = '';

            console.log('board')
            console.log(board)

            tagProperties = commonFunctions.buildProperty(thisComp.$data, board.properties);
            tagContent = commonFunctions.buildContent(board.content);

            // Opening parent html tag including its properties and innerHTML.
            html += '<' + board.tag + ' ' + tagProperties + '>' + tagContent;


            if (board.childTags.length > 0) {
              // Child tag iteration.
              board.childTags.forEach((childTag) => {
                childTagProperties = commonFunctions.buildProperty(thisComp.$data, childTag.properties);
                childTagContent = commonFunctions.buildContent(childTag.content);

                // Opening child html tag including its properties, innerHTML and closing tag.
                html += '<' + childTag.tag + ' ' + childTagProperties + '>'
                  + childTagContent + '<\/' + childTag.tag + '>';
              });
            }

            // Closing tag of parent.
            html += '<\/' + board.tag + '>';

            // Return the above built html.
            return html;
          },
          getPropertyValue(tag) {
            let propertyValue = "";
            let propertiesConcat = "";
            this.hideRow = false;
            console.log('properties');
            console.log(tag.properties);

            if ( tag.properties.length > 0 ) {

              let thisComp = this;
              let property1 = "";

              tag.properties.forEach(function (property) {
                propertyValue = thisComp.$data[property.value.toString()];

                console.log("propertyValue");
                console.log(property.property);
                console.log(property.value);
                console.log(thisComp.userManualLink);
                console.log(thisComp.outstandingInvoicesVisible);

                if ( propertyValue == undefined ) propertyValue = property.value;

                if (property.condition > 0) {
                  console.log('property.value');
                  console.log(eval(property.value));
                  if ( eval(property.value) ) {
                    thisComp.hideRow = false;
                  }
                  else {
                    thisComp.hideRow = true;
                  }
                }
                else {
                  property1 = property.property + '="' + propertyValue + '" ';
                }




                console.log(property1.toString());


                propertiesConcat += property1;

                console.log(propertiesConcat);
                console.log("");
                console.log("");
              });

            }


            return propertiesConcat;
          },
          loadUserGuideId(){
              // debugger;
              let url = this.$localApiURL + this.fileModel.getRoute("getUserGuideDocumentId") + "?clientTypeId=" + this.contactModel.clientTypeId + "&&token=" + localStorage.getItem('jwt');
              this.$http.get(url).then((res) => {
                  // debugger;
                  let url2 = this.$localApiURL + this.fileModel.getRoute("getFile") + res.data.fileName + "?token=" + localStorage.getItem('jwt');
                  this.userManualLink = url2;
              }).catch((error) => {
                  console.error(error);
              });
          },
          loadOutstandingInvoices: function () {
              let url = this.$localApiURL + this.outstandingInvoicesCollection.getRoute("fetch") + "?count=" + this.countOutstandingInvoice + "&token=" + localStorage.getItem('jwt');
              this.$http.post(url).then((res) => {
                  this.totalOutstandingInvoices = res.data;
              }).catch((error) => {
                  console.error(error);
              });
          },
          getCarouselHeight() {
            return window.innerHeight - 300 - 25 + "px";
          },
          loadCarouselPages() {
            this.pages = [];
            let url = this.$localApiURL + this.clientDashboardCollection.getRoute("pages") + "?isWelcomePage=true&token=" + localStorage.getItem('jwt');
            this.$http.get(url).then((response) => {
              if (response.data !== null && response.data !== {}) {
                this.pages = response.data;

                console.log("welcome page pages")
                console.log(this.pages)
              }
            })
            .catch((error) => {
              console.error(error);
            });
          }
        },
		    created: function () {
            this.loadDetails();
            this.loadOutstandingInvoices();
            this.loadCarouselPages();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Welcome.vue